import React, {useContext, useState} from 'react'
import {vote_getVotedItems_Api} from "../../../../apis";
import useTranslate from "../../../../modules/local/useTranslate";
import {LoginContext} from "../../../../components/LoginContext";
import EmptyHolder from "../../../../components/EmptyHolder";
import {LazyPagination} from "../../../../modules/asyncCache/components/LazyPagination";
import {GodWordItem} from "../components/GodWordItem";
import {useGodWords} from "../functions/useGodWords";
import {SelectEntityItem} from "../../../../components/SelectEntityItem";
import {godwordsSchema} from "../../../../apis/godwords";

export const LikedItems = ({handleDisplayById}) => {
    const t = useTranslate()
    const login = useContext(LoginContext)
    const [refreshToken, setRefreshToken] = useState()
    const [
        current,
        setCurrent
    ] = useState('0')

    const onRefresh = () => {
        setRefreshToken(Date.now())
    }

    const {
        modal,
        handleAction,
        onVote,
        onDevote
    } = useGodWords({
        notifyListeners: {
            onVotedSuccess: (result, data) => {
                onRefresh()
            },
            onDevotedSuccess: (result, data) => {
                onRefresh()
            },
        }
    })

    return (
        <div className="flex flex-col gap-4">
            <LazyPagination
                key={
                    vote_getVotedItems_Api.path
                        .replace(':type', 'god_word')
                    + refreshToken
                }
                query={{
                    ':type': 'god_word'
                }}
                renderEmpty={() => <EmptyHolder subTitle={t('no item yet')}/>}
                apiInfo={vote_getVotedItems_Api}
                renderItem={item => {
                    return (
                        <SelectEntityItem
                            item={item.owner}
                            schema={godwordsSchema}>
                            {(item) => {
                                return (
                                    <GodWordItem item={item}
                                                 {...{handleDisplayById, handleAction, onVote, onDevote}}
                                    />
                                )
                            }}
                        </SelectEntityItem>
                    )
                }}
            />
            {modal}
        </div>
    )
}

